export const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.base.alfamall";

export const GET_APP_LABEL = "Get our App Now";
export const OPEN_APP_LABEL = "Open app";
export const CONTINUE_IN_BROWSER_LABEL = "Not now, continue in browser";
export const EXPLORE_IN_APP_LABEL = "Explore www.alfamall.com in...";
export const APP_NAME = "AlfaMall app";
export const DISMISS_STORAGE_KEY = "alfamallAppPromptDismissed";
export const APP_PROMPT_DELAY_MS = 15000;

const HIDDEN_APP_PROMPT_PATHS = [
  "/cart/checkout",
  "/login",
  "/password-protected",
  "/islamic-12-12",
  "/vertica",
];

export function isAppPromptHidden(pathname = "") {
  return HIDDEN_APP_PROMPT_PATHS.some(
    (path) => pathname === path || pathname.startsWith(`${path}/`),
  );
}

export function openPlayStore() {
  window.open(PLAY_STORE_URL, "_blank", "noopener,noreferrer");
}

export function rememberAppPromptDismissed() {
  sessionStorage.setItem(DISMISS_STORAGE_KEY, "1");
}

export function isAppPromptDismissed() {
  return sessionStorage.getItem(DISMISS_STORAGE_KEY) === "1";
}
